/** @module Merchandising/VersionGalleryCommentView */
define([
	"dojo/_base/declare",
	"SiteAdmin/Comment/Gallery",
	"./VersionView"
], function (declare, Widget, VersionView) {

	return declare([Widget, VersionView]);
});